import { useFormContext, useWatch } from 'react-hook-form';

import { cellPath, type VariantRowsInput } from '../api/variant-mappers';

/** A variant's cost as drafted in the row form the card sits in, for a margin that follows it. */
export function useWatchedVariantCost(id: string) {
  const { control } = useFormContext<VariantRowsInput>();
  return useWatch({ control, name: cellPath(id, 'cost') });
}
